import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultAdministratorInfo } from '../interfaces/User'
import { useAuth } from './useAuth'

interface C104AdministratorsGetProps {
  execAdministratorsGet: () => Promise<ResultAdministratorInfo>
  loading: loadStatus
}
// C104 管理者情報一覧取得API呼出
export const useC104AdministratorsGet = (): C104AdministratorsGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const execAdministratorsGet = async () => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const response = await axios.get(`${baseUrl}${stage}${apiUrl.usersPath}`, {
        headers: header,
        validateStatus: () => true,
      })

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execAdministratorsGet, loading }
}
